module.exports = __webpack_public_path__ + "assets/media/android-img.bd04385b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android-img.jpg
// module id = 545
// module chunks = 0